import React, { useEffect, useState, useRef, useMemo } from 'react'
import './login.scss';
import LoginLeft from './LoginLeft';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useHistory } from 'react-router';
import Notify from 'lib/Utils/Alert';
import Authenticate from 'lib/Core/Authenticate';
import Spinner from 'react-bootstrap/Spinner';
import NotificationAlert from "react-notification-alert";
import { IoArrowBack } from "react-icons/io5";
import { IoArrowBackCircle } from "react-icons/io5";

const securityGroups = [
  "purchaser"
]

const ForgotPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [recoveryCode, setRecoveryCode] = useState('');
  const [emailError, setEmailError] = useState(null);
  const [recoveryCodeError, setRecoveryCodeError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [recoveryPassword, setRecoveryPassword] = useState(false)
  const [emailLoader,setEmailLoader] = useState(false);
  const history = useHistory();
  const notifyRef = useRef();
  const form = useRef();
  const [formState, setFormState] = useState("normal");
  // const authCtl = new Authenticate();
  const checkEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError('Enter a valid Email address');
    }
    else {
      setEmailError(null);
    }
  }

  const checkPassword = () => {
    const hasUpperCase = /[A-Z]/; 
    const hasLowerCase = /[a-z]/; 
    const hasNumber = /[0-9]/;    
    const hasSpecialChar = /[!@#?$%*&]/;
    const minLength = /^.{8,}$/; 

    
    if (!minLength.test(password)) {
      setPasswordError("Password must be at least 8 characters long.");
      return;
  }

  if (!hasUpperCase.test(password)) {
    setPasswordError("Password must include at least one uppercase letter.");
      return;
  }

  if (!hasLowerCase.test(password)) {
    setPasswordError("Password must include at least one lowercase letter.");
      return;
  }

  if (!hasNumber.test(password)) {
    setPasswordError("Password must include at least one number.");
      return;
  }

  if (!hasSpecialChar.test(password)) {
    setPasswordError("Password must include at least one special character (!, @, #, ?,$,%,&,*).");
      return;
  }

    
      setPasswordError(null)
  }

  const checkConfirmPassword = () => {
    const hasUpperCase = /[A-Z]/; 
    const hasLowerCase = /[a-z]/; 
    const hasNumber = /[0-9]/;    
    const hasSpecialChar = /[!@#?$%*&]/;
    const minLength = /^.{8,}$/; 

    if (!minLength.test(confirmPassword)) {
        setConfirmPasswordError("Password must be at least 8 characters long.");
        return;
    }

    if (!hasUpperCase.test(confirmPassword)) {
        setConfirmPasswordError("Password must include at least one uppercase letter.");
        return;
    }

    if (!hasLowerCase.test(confirmPassword)) {
        setConfirmPasswordError("Password must include at least one lowercase letter.");
        return;
    }

    if (!hasNumber.test(confirmPassword)) {
        setConfirmPasswordError("Password must include at least one number.");
        return;
    }

    if (!hasSpecialChar.test(confirmPassword)) {
        setConfirmPasswordError("Password must include at least one special character (!, @, #, ?,$,%,&,*).");
        return;
    }

    setConfirmPasswordError(null);
  }

  const checkRecoveryCode = () => {
    if (recoveryCode.trim() =='') {
      setRecoveryCodeError('Enter a valid code')
    }

    else {
      setRecoveryCodeError(null)
    }
  }

  const authCtl = useMemo(() => new Authenticate(securityGroups), [securityGroups]);

  // function NotifyWarning(msg) {
  //   Notify(notifyRef, "warning", msg);
  // }
const emailLoaderFile = () =>{
  setTimeout(() => {
    setEmailLoader(false)
  }, 1500);
  
}
  const onSubmitMail = () => {
   setEmailLoader(true);
    if (emailError === null) {
      
      authCtl.forgotPassword(email).then(() => {
        setRecoveryPassword(!recoveryPassword)
        emailLoaderFile()
        Notify(notifyRef, "info", "An email was sent to your inbox with further instructions to recover your password");
      }).catch(reason => {
        emailLoaderFile()
        Notify(notifyRef, "danger", reason);
      });

    }
    else {
      emailLoaderFile()
      checkEmail();
    }
  }

  const confirmPasswordFunction = () => {
    if (passwordError === null && confirmPasswordError === null && recoveryCodeError === null) {
      


      if (password !== confirmPassword) {
        Notify(notifyRef, "info", "The passwords don't match, please verify.");
      }
     else
      
      {
        authCtl.confirmForgotPassword(recoveryCode, email, password).then(() => {
          history.replace("/purchaser-auth/login", {state: {msg : "Password updated successfully, please login with your new password."}})

        }).catch(error => {
          
          
          if(error.length >100){
            Notify(notifyRef,"danger","Invalid verification code provided, please try again.")
          }else{
            Notify(notifyRef,"danger",error)
          }
        });
      }

    } else {
      checkPassword();
      checkConfirmPassword()
      checkRecoveryCode()
    }

  }

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        if (emailError === null) {
          onSubmitMail()
        }
        else {
          checkEmail();
        }
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [emailError]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        if (passwordError === null && confirmPasswordError === null && recoveryCodeError === null) {
          confirmPasswordFunction()
        }
        else {
          checkPassword();
          checkConfirmPassword()
          checkRecoveryCode()
        }
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [passwordError, confirmPasswordError,recoveryCodeError ]);

  const redirectTohome = () =>{
    history.replace("/purchaser-auth/login")
    }

  return (
    <div className='authPage'>
      <NotificationAlert ref={notifyRef} />
      <div className="wrap">
        <div className="row g-0">
          <div className="col-lg-6">
            <LoginLeft hideCursor={true}/>
          </div>
          {recoveryPassword ?
            <div className="col-lg-6">
              <div className="authRight h-100 p-4 p-lg-5">
             
                <div className='authRightContent'>
                <div className="d-flex align-items-center back_button_design" style={{cursor:"pointer"}} onClick={redirectTohome}>
                <IoArrowBackCircle className="fs-5 me-1" />
                <p className=" d-flex justify-content-start my-0  me-md-2 me-lg-1 me-0" >
                Back
                </p>
                </div>
                  <img src="../../assets/img/ncentiva.png" alt="" className='mb-3 d-block d-lg-none' />
                  <h3>Input the recovery code you received</h3>
                  <div className="formField">
                    <label htmlFor="">Recovery Code</label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1"><i className='bx bxs-envelope'></i></InputGroup.Text>
                      <Form.Control
                        placeholder="Enter your recovery code"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        type='tel'
                        value={recoveryCode}
                        onChange={(e) => setRecoveryCode(e.target.value)}
                        onKeyUp={checkRecoveryCode}
                        className={recoveryCodeError && 'border-danger'}
                      />
                    </InputGroup>
                    {recoveryCodeError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{recoveryCodeError}</p>}
                  </div>
                  <div className="formField">
                    <label htmlFor="">Email</label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1"><i className='bx bxs-envelope'></i></InputGroup.Text>
                      <Form.Control
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        disabled
                        value={email}
                      />
                    </InputGroup>
                  </div>
                  <div className="formField">
                    <label htmlFor="">New Password</label>
                    <div className="position-relative">
                      <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon2"><i className='bx bxs-lock' ></i></InputGroup.Text>
                        <Form.Control
                          placeholder="Enter new password"
                          aria-label="password"
                          aria-describedby="basic-addon2"
                          type={showPassword ? 'text' : 'password'}
                          className={`pe-5 ${passwordError && 'border-danger'}`}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onKeyUp={checkPassword}
                        />
                      </InputGroup>
                      <button className='btn-pass position-absolute end-0 top-0 text-primary h-100 px-3 bg-transparent border-0' onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                      </button>
                    </div>
                    {passwordError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{passwordError}</p>}
                  </div>
                  <div className="formField">
                    <label htmlFor="">Confirm Password</label>
                    <div className="position-relative">
                      <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon2"><i className='bx bxs-lock' ></i></InputGroup.Text>
                        <Form.Control
                          placeholder="Enter new password again"
                          aria-label="password"
                          aria-describedby="basic-addon2"
                          type={confirmShowPassword ? 'text' : 'password'}
                          className={`pe-5 ${confirmPasswordError && 'border-danger'}`}
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          onKeyUp={checkConfirmPassword}
                        />
                      </InputGroup>
                      <button className='btn-pass position-absolute end-0 top-0 text-primary h-100 px-3 bg-transparent border-0' onClick={() => setConfirmShowPassword(!confirmShowPassword)}>
                        {confirmShowPassword ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                      </button>
                    </div>
                    {confirmPasswordError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{confirmPasswordError}</p>}
                  </div>
                  <button className='btn btn-primaryTwo w-100 mt-4'
                  onClick={confirmPasswordFunction}
                  >Recover Password</button>
                </div>
              </div>
            </div>
            :
            <div className="col-lg-6">
              <div className="authRight h-100 p-4 p-lg-5">
                <div className='authRightContent'>
                 <div className="d-flex align-items-center back_button_design" style={{cursor:"pointer"}} onClick={redirectTohome}>
                  <IoArrowBackCircle className="fs-5 me-1" />
                    <p className=" d-flex justify-content-start my-0 me-sm-5 me-md-2 me-lg-1 me-0" >
                     Back
                    </p>
                    </div>
                  <img src="../../assets/img/ncentiva.png" alt="" className='mb-3 d-block d-lg-none' />
                  <h3>Enter your email</h3>
                  <div className="formField">
                    <label htmlFor="">Email</label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1"><i className='bx bxs-envelope'></i></InputGroup.Text>
                      <Form.Control
                        placeholder="Enter your email"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        type='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyUp={checkEmail}
                        className={emailError && 'border-danger'}
                      />
                    </InputGroup>
                    {emailError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{emailError}</p>}
                  </div>
                  <button className='btn btn-primaryTwo w-100 mt-4' onClick={onSubmitMail} disabled={emailLoader}>{!emailLoader && "Continue"}{
                    emailLoader &&
                    <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    style={{
                    margin: "0px 8px"
                    }}
                  />
                    }</button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword